"use client"

import { ResourceCard } from "@/components/resources/resource-card"
import { cn } from "@/lib/utils"
import type { ResourceCategory } from "@/types/resources"

interface ResourceColumnProps {
    category: ResourceCategory
    index: number
    className?: string
}

export function ResourceColumn({
    category,
    index,
    className,
}: ResourceColumnProps) {
    const formattedIndex = String(index + 1).padStart(2, "0")

    return (
        <section
            aria-labelledby={`category-${category.id}`}
            className={cn(
                "flex flex-col border border-border/70 bg-background p-4 transition-colors sm:p-5 dark:border-border/40",
                className
            )}
        >
            {/* Column Header */}
            <div className="mb-3 flex items-center justify-between border-border/60 border-b pb-3 dark:border-border/30">
                <div className="flex items-center gap-2">
                    <span className="font-mono text-[11px] text-muted-foreground">
                        {formattedIndex}
                    </span>
                    <h2
                        id={`category-${category.id}`}
                        className="font-semibold text-foreground text-sm tracking-tight"
                    >
                        {category.title}
                    </h2>
                </div>
                <span className="font-mono text-[11px] text-muted-foreground">
                    {category.items.length}
                </span>
            </div>

            {/* Items List */}
            <div className="flex flex-col gap-1">
                {category.items.map((item) => (
                    <ResourceCard key={item.id} item={item} />
                ))}
            </div>
        </section>
    )
}
